import { lazy } from 'solid-js'
import { messages } from '../../pages/booking-policies-page/booking-policies-page-routing.messages.en.js'

export default {
    component: lazy(() => import('../../pages/booking-policies-page/booking-policies-page.jsx')),
    descriptionMessage: messages.descriptionMessage,
    path: '/booking-policies',
    showFooter: true,
    showHeaderMenu: true,
    showSidebar: false,
    titleMessage: messages.titleMessage,
}
